import { useMemo, useState } from "react";
import { feedItems } from "@/mocks/blackmole";
import { chipTone, dotTone, textTone } from "./tone";

const kinds = ["全部", "首曝", "独家", "速报", "进展"] as const;

export default function LiveFeed() {
  const [active, setActive] = useState<(typeof kinds)[number]>("全部");
  const shown = useMemo(
    () => (active === "全部" ? feedItems : feedItems.filter((f) => f.kind === active)),
    [active]
  );

  return (
    <section id="feed" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-700">
              <span className="inline-block h-px w-6 bg-primary-500"></span>
              快讯流 · 突发爆料逐条刷新
            </div>
            <h2 className="mt-2 flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              主时间线
              <span className="flex items-center gap-1.5 text-sm font-semibold text-primary-700">
                <i className="ri-time-line text-primary-500"></i>
                {shown.length} 条在列
              </span>
            </h2>
          </div>

          <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-200 bg-background-50 p-1">
            {kinds.map((k) => (
              <button
                key={k}
                type="button"
                onClick={() => setActive(k)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
                  active === k
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:bg-secondary-100 hover:text-foreground-950"
                }`}
              >
                {k}
              </button>
            ))}
          </div>
        </div>

        <ol className="relative">
          <span
            aria-hidden
            className="absolute bottom-4 left-[7px] top-2 w-px bg-background-200 md:left-[9px]"
          ></span>
          {shown.map((item) => (
            <li key={item.id} className="relative pb-5 pl-8 md:pl-12">
              <span
                className={`absolute left-0 top-1.5 flex h-4 w-4 items-center justify-center rounded-full border-4 border-background-50 md:h-5 md:w-5 ${dotTone[item.tone]}`}
              ></span>
              <article className="group cursor-pointer rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200">
                <div className="flex flex-wrap items-center gap-2">
                  <span className={`whitespace-nowrap text-xs font-semibold ${textTone[item.tone]}`}>
                    <i className="ri-time-line mr-1 align-middle"></i>
                    {item.time}
                  </span>
                  {item.pinned && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
                      <i className="ri-pushpin-2-fill text-xs"></i>
                      置顶
                    </span>
                  )}
                  <span
                    className={`inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-semibold ${chipTone[item.tone]}`}
                  >
                    {item.kind}
                  </span>
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                    #{item.tag}
                  </span>
                  <span className="ml-auto hidden items-center gap-1 text-xs text-foreground-500 sm:inline-flex">
                    追踪中
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                  </span>
                </div>
                <h3 className="mt-2.5 text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">{item.lead}</p>
              </article>
            </li>
          ))}
        </ol>

        <div className="mt-4 flex flex-col items-center justify-center gap-3">
          <button
            type="button"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-loader-4-line text-base"></i>
            展开更多快讯
          </button>
          <p className="text-xs text-foreground-500">快讯按时间倒序排列，最新猛料总在列表最前。</p>
        </div>
      </div>
    </section>
  );
}